import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Alert } from 'react-bootstrap';
import {
    deleteAttendance, deleteEntity, deleteItem,
    fetchChapterMembers,
    fetchEventItem,
    postAttendance, postEntity, postItem,
    restartEvent,
    startEvent,
    stopEvent, updateAttendance,
} from "../redux/actions";
import {
    eventSelector,
    userSelector,
    locationSelector,
    authSelector,
    eventAttendanceSelector, eventEntitySelector, eventItemSelector, itemSelector, entitySelector, rankSelector, chapterMemberSelector
} from "../redux/selectors";
import { toArray } from '../common/util';
import { hasPermission } from "../common/permissions";
import EventsAttendeeForm from './EventsAttendeeForm';
import EventsAttendee from './EventsAttendee';
import EventsEntityForm from './EventsEntityForm';
import EventsEntity from './EventsEntity';
import EventsItemForm from './EventsItemForm';
import Username from "../common/Username";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faUserFriends, faDungeon, faDragon, faHatWizard, faFistRaised, faBookDead, faScroll, faHourglass, faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import Moment from 'react-moment';
import HoverEdit from '../common/hoveredit';
import EventsItem from "./EventsItem";

class EventDetail extends Component {

    constructor(props) {
        super(props);
        this.attendeeSubmit = this.attendeeSubmit.bind(this);
        this.entitySubmit = this.entitySubmit.bind(this);
        this.itemSubmit = this.itemSubmit.bind(this);
        this.handleStart = this.handleStart.bind(this);
        this.handleStop = this.handleStop.bind(this);
        this.handleRestart = this.handleRestart.bind(this);
        this.stopAttendee = this.stopAttendee.bind(this);
        this.editAttendee = this.editAttendee.bind(this);
        this.delAttendee = this.delAttendee.bind(this);
        this.delEntity = this.delEntity.bind(this);
        this.delItem = this.delItem.bind(this);
    }

    componentDidMount() {
        document.title = "Addiction | DKP | Event " + this.props.match.params.id;
        this.props.getEvent(this.props.match.params.id)
    }

    attendeeSubmit(values) {
        if (toArray(this.props.users).filter((user) => user.displayName.toLowerCase() === values.member.toLowerCase()).length === 1) {
            let newValues = {
                ...values,
                user: toArray(this.props.users).filter((user) => user.displayName.toLowerCase() === values.member.toLowerCase())[0]
            };
            this.props.submitAttendee(
                toArray(this.props.events.data).filter((event) => event.slug === this.props.match.params.id)[0].chapterId,
                toArray(this.props.events.data).filter((event) => event.slug === this.props.match.params.id)[0].section,
                toArray(this.props.events.data).filter((event) => event.slug === this.props.match.params.id)[0].slug,
                newValues)
        }
    }

    entitySubmit(values) {
        let event = toArray(this.props.events.data).filter((event) => event.slug === this.props.match.params.id)[0];
        this.props.submitEntity(event.chapterId, event.section, event.slug, values)
    }

    itemSubmit(values) {
        if (toArray(this.props.users).filter((user) => user.displayName.toLowerCase() === values.member.toLowerCase()).length === 1) {
            let event = toArray(this.props.events.data).filter((event) => event.slug === this.props.match.params.id)[0];
            let newValues = {
                ...values,
                member: toArray(this.props.users).filter((user) => user.displayName.toLowerCase() === values.member.toLowerCase())[0].id,
            };
            this.props.submitItem(event.chapterId, event.section, event.slug, newValues)
        }
    }

    handleStart(chapter, section, event) {
        this.props.start(chapter, section, event)
    }

    handleStop(chapter, section, event, stopTime) {
        this.props.stop(chapter, section, event, stopTime)
    }

    handleRestart(chapter, section, event) {
        this.props.restart(chapter, section, event)
    }

    stopAttendee(data) {
        if (!data.attendee.stopped) {
            this.props.updateAttendee(data.event.chapterId, data.event.section, data.event.slug, { ...data.attendee, stopped: new Date() })
        }
    }

    editAttendee(data) {
        this.props.updateAttendee(data.event.chapterId, data.event.section, data.event.slug, data.attendee)
    }

    delAttendee(data) {
        this.props.delAttendee(data.event.chapterId, data.event.section, data.event.slug, data.attendee)
    }

    delEntity(data) {
        this.props.delEntity(data.event.chapterId, data.event.section, data.event.slug, data.entity)
    }

    delItem(data) {
        this.props.delItem(data.event.chapterId, data.event.section, data.event.slug, data.item)
    }

    render() {
        if (hasPermission('dkp.change_event', this.props.auth.permissions)) {
            if (toArray(this.props.events.data).filter((event) => event.slug === this.props.match.params.id).length) {
                return (
                    <div>
                        {toArray(this.props.events.data)
                            .filter((event) => event.slug === this.props.match.params.id)
                            .map(event => {
                                if (event.started === null) {
                                    return { ...event, started: new Date().toString() }
                                } else {
                                    return event
                                }
                            })
                            .map(event => {
                                if (event.stopped === null) {
                                    return { ...event, stopped: new Date().toString() }
                                } else {
                                    return event
                                }
                            })
                            .map((event) => (
                                <div key={`${event.id}-event`}>
                                    <h1>{event.title}</h1>
                                    <div className="panel-adt">
                                        <h2><FontAwesomeIcon className="text-primary" icon={faDungeon} fixedWidth /> {event.location.map((location) => this.props.locations.data[location].title).join(", ")}</h2>
                                        <div>
                                            <FontAwesomeIcon className="text-primary" icon={faFistRaised} fixedWidth /> Raid Leader: <Username user={this.props.users[event.eventLeader]} rank={this.props.ranks[this.props.users[event.eventLeader].rank]} />
                                        </div>
                                        <div>
                                            <FontAwesomeIcon className="text-primary" icon={faCalendarDay} fixedWidth /> <Moment>{event.started}</Moment>
                                        </div>
                                        <div>
                                            <FontAwesomeIcon className="text-primary" icon={faBookDead} fixedWidth /> Kills: <span className="text-primary">{event.entities.length}</span>
                                        </div>
                                        <div>
                                            <FontAwesomeIcon className="text-primary" icon={faHatWizard} fixedWidth /> Items: <span className="text-primary">{event.awardedItems.length}</span>
                                        </div>
                                        <div>
                                            <FontAwesomeIcon className="text-primary" icon={faHourglass} fixedWidth /> DKP per hour: <span className="text-primary">{event.dkp}</span>
                                        </div>
                                        <div>
                                            <FontAwesomeIcon className="text-primary" icon={faScroll} fixedWidth /> Maximum DKP earned: <span className="text-primary">{
                                                (
                                                    event.dkp * (new Date(event.stopped).getTime() - new Date(event.started).getTime()) / (3600 * 1000)
                                                    + event.entities.reduce((total, entity) => total + parseFloat(this.props.eventEntities.data[entity].dkp), 0)
                                                ).toFixed(2)
                                            }</span> in <span className="text-primary">{((new Date(event.stopped).getTime() - new Date(event.started).getTime()) / (3600 * 1000)).toFixed(1)}</span> hours
                                        </div>
                                    </div>
                                    <div className="panel-adt">
                                        {(event.state === "scheduled") ?
                                            (
                                                <Alert bsStyle="danger" style={{ marginBottom: "0" }}>This raid is not started.</Alert>
                                            ) : (null)
                                        }
                                        {(event.state === "in_progress") ?
                                            (
                                                <Alert bsStyle="success" style={{ marginBottom: "0" }}>This raid is in progress.</Alert>
                                            ) : (null)
                                        }
                                        {(event.state === "finished") ?
                                            (
                                                <Alert bsStyle="warning" style={{ marginBottom: "0" }}>This raid is finished.</Alert>
                                            ) : (null)
                                        }
                                    </div>
                                    <div className="panel-adt">
                                        <h3><FontAwesomeIcon className="text-primary" icon={faUsers} fixedWidth /> {event.attendees.filter((attendee) => this.props.eventAttendance.data[attendee].standby === false).filter((attendee) => this.props.eventAttendance.data[attendee].stopped === null).length} Active Attendees:</h3>
                                    </div>
                                    {event.attendees
                                        .filter((attendee) => this.props.eventAttendance.data[attendee].standby === false)
                                        .sort((a, b) => this.props.users[this.props.eventAttendance.data[a].user].displayName.toLowerCase() !== this.props.users[this.props.eventAttendance.data[b].user].displayName.toLowerCase() ? this.props.users[this.props.eventAttendance.data[a].user].displayName.toLowerCase() < this.props.users[this.props.eventAttendance.data[b].user].displayName.toLowerCase() ? -1 : 1 : 0)
                                        .sort((a, b) => new Date(this.props.eventAttendance.data[a].stopped).getTime() - new Date(this.props.eventAttendance.data[b].stopped).getTime())
                                        .map((attendee) => (
                                            <div className="panel-adt" key={`${attendee}-attendee`} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                                                <HoverEdit handleStop={this.stopAttendee} handleDelete={this.delAttendee} target={{ attendee: this.props.eventAttendance.data[attendee], event: event }}>
                                                    <EventsAttendee attendeeEdit={this.editAttendee} attendee={attendee} event={event} eventAttendance={this.props.eventAttendance} eventItems={this.props.eventItems} eventEntities={this.props.eventEntities} entities={this.props.entities} items={this.props.items} users={this.props.users} edit={this.props.edit} />
                                                </HoverEdit>
                                            </div>
                                        ))}
                                    {event.attendees
                                        .filter((attendee) => this.props.eventAttendance.data[attendee].standby === true).length > 0 ?
                                        (
                                            <div>
                                                <div className="panel-adt">
                                                    <h3><FontAwesomeIcon className="text-primary" icon={faUserFriends} fixedWidth /> {event.attendees.filter((attendee) => this.props.eventAttendance.data[attendee].standby === true).filter((attendee) => this.props.eventAttendance.data[attendee].stopped === null).length} Active Standby:</h3>
                                                </div>
                                                {event.attendees
                                                    .filter((attendee) => this.props.eventAttendance.data[attendee].standby === true)
                                                    .sort((a, b) => this.props.users[this.props.eventAttendance.data[a].user].displayName.toLowerCase() !== this.props.users[this.props.eventAttendance.data[b].user].displayName.toLowerCase() ? this.props.users[this.props.eventAttendance.data[a].user].displayName.toLowerCase() < this.props.users[this.props.eventAttendance.data[b].user].displayName.toLowerCase() ? -1 : 1 : 0)
                                                    .map((attendee) => (
                                                        <div className="panel-adt" key={`${attendee}-attendee`} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                                                            <HoverEdit handleStop={this.stopAttendee} handleDelete={this.delAttendee} target={{ attendee: this.props.eventAttendance.data[attendee], event: event }}>
                                                                <EventsAttendee attendeeEdit={this.editAttendee} attendee={attendee} event={event} eventAttendance={this.props.eventAttendance} eventItems={this.props.eventItems} eventEntities={this.props.eventEntities} entities={this.props.entities} items={this.props.items} users={this.props.users} edit={this.props.edit} />
                                                            </HoverEdit>
                                                        </div>
                                                    ))}
                                            </div>
                                        ) : null}

                                    <div className="panel-adt">
                                        <EventsAttendeeForm onSubmit={this.attendeeSubmit} event={event} users={this.props.users} />
                                    </div>
                                    <div className="panel-adt">
                                        {toArray(this.props.chapterMembers.data)
                                            .filter((member) => member.chapter === event.chapterId)
                                            .filter((member) => member.leaveDate === null)
                                            .filter((member) => !event.attendees.map((attendee) => this.props.eventAttendance.data[attendee].user).includes(member.member))
                                            .map((member) => (
                                                <a href="#" key={`${member.id}-member`} onClick={() => this.attendeeSubmit({ member: this.props.users[member.member].displayName })}>{this.props.users[member.member].displayName} </a>
                                            ))
                                        }
                                    </div>
                                    <div className="panel-adt">
                                        <h3><FontAwesomeIcon className="text-primary" icon={faDragon} fixedWidth /> Boss Kills</h3>
                                    </div>
                                    {event.entities
                                        .sort((a, b) => (new Date(this.props.eventEntities.data[a].created).getTime() - new Date(this.props.eventEntities.data[b].created).getTime()))
                                        .map((entity) => (
                                            <div className="panel-adt" key={`${entity}-entity`} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                                                <HoverEdit handleDelete={this.delEntity} target={{ entity: this.props.eventEntities.data[entity], event: event }}>
                                                    <EventsEntity entity={entity} event={event} entities={this.props.entities} eventEntities={this.props.eventEntities} />
                                                </HoverEdit>
                                            </div>
                                        ))}
                                    <div className="panel-adt">
                                        <EventsEntityForm onSubmit={this.entitySubmit} event={event} locations={this.props.locations} errors={this.props.eventEntities.error} />
                                    </div>
                                    <div className="panel-adt">
                                        <h3><FontAwesomeIcon className="text-primary" icon={faHatWizard} fixedWidth /> Items</h3>
                                    </div>
                                    {event.awardedItems
                                        .map((item) => (
                                            <div className="panel-adt" key={`${item}-item`} style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                                                <HoverEdit handleDelete={this.delItem} target={{ item: this.props.eventItems.data[item], event: event }}>
                                                    <EventsItem item={item} items={this.props.items} eventItems={this.props.eventItems} users={this.props.users} />
                                                </HoverEdit>
                                            </div>
                                        ))}
                                    <div className="panel-adt">
                                        <EventsItemForm onSubmit={this.itemSubmit} event={event} errors={this.props.eventItems.error} />
                                    </div>
                                    <div className="panel-adt text-right">
                                        {(event.state === "scheduled") ?
                                            (
                                                <Button onClick={() => this.handleStart(event.chapterId, event.section, event.slug)}>Start</Button>
                                            ) : (null)
                                        }
                                        {(event.state === "in_progress") ?
                                            (
                                                <Button onClick={() => this.handleStop(event.chapterId, event.section, event.slug)}>Stop</Button>
                                            ) : (null)
                                        }
                                        {(event.state === "finished") ?
                                            (
                                                <Button onClick={() => this.handleRestart(event.chapterId, event.section, event.slug)}>Restart</Button>
                                            ) : (null)
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                )
            } else { return null }
        } else {
            return <Redirect to="/" />
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    events: eventSelector(state),
    users: userSelector(state),
    ranks: rankSelector(state),
    locations: locationSelector(state),
    eventAttendance: eventAttendanceSelector(state),
    eventItems: eventItemSelector(state),
    eventEntities: eventEntitySelector(state),
    items: itemSelector(state),
    entities: entitySelector(state),
    chapterMembers: chapterMemberSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getEvent: (item) => dispatch(fetchEventItem(item)),
    getChapterMembers: (chapter) => dispatch(fetchChapterMembers(chapter)),
    submitAttendee: (chapter, section, event, attendee) => dispatch(postAttendance(chapter, section, event, attendee)),
    submitEntity: (chapter, section, event, entity) => dispatch(postEntity(chapter, section, event, entity)),
    submitItem: (chapter, section, event, item) => dispatch(postItem(chapter, section, event, item)),
    start: (chapter, section, event) => dispatch(startEvent(chapter, section, event)),
    stop: (chapter, section, event, stopTime) => dispatch(stopEvent(chapter, section, event, stopTime)),
    restart: (chapter, section, event) => dispatch(restartEvent(chapter, section, event)),
    updateAttendee: (chapter, section, event, attendee) => dispatch(updateAttendance(chapter, section, event, attendee)),
    delAttendee: (chapter, section, event, attendee) => dispatch(deleteAttendance(chapter, section, event, attendee)),
    delEntity: (chapter, section, event, entity) => dispatch(deleteEntity(chapter, section, event, entity)),
    delItem: (chapter, section, event, item) => dispatch(deleteItem(chapter, section, event, item)),

});

export default connect(mapStateToProps, mapDispatchToProps)(EventDetail);


// WEBPACK FOOTER //
// ./src/Officer/EventDetail.js